import { partnerApi2 } from '@subaio/api-specs'

import { asContainer } from 'lib/container'

import { OpenApi } from 'components/OpenApi'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/partner-api/v2',
	title: 'Partner API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => <OpenApi apiDocument={partnerApi2} statuspageApi={statuspageApi} />,
})
